
export default class BeneficiosCondicionesItem extends React.Component {
  constructor() {
    super();

    this.state = {
        eventKey: Math.random(),
        titleColorClass: 'titulo-beneficio-item',
        icon: <i className="fa fa-chevron-circle-down"></i>
    }
    
  }

  changePanelStatus(e)
  {
    if(this.state.titleColorClass == 'titulo-beneficio-item'){
      this.setState({ titleColorClass: 'titulo-beneficio-item-seleccionado', icon: <i className="fa fa-chevron-circle-up"></i> })
    } else {
      this.setState({ titleColorClass: 'titulo-beneficio-item', icon: <i className="fa fa-chevron-circle-down"></i> })
    }
  }

  render() {
    return (
      <Panel eventKey={this.props.id} onToggle={(e) => this.changePanelStatus(e)} >
          <Panel.Heading>
            <Panel.Title toggle className={ this.state.titleColorClass } >
              {this.props.item.CSTituloSeccionText}
              <div className="cont-icon-beneficio">
                { this.state.icon }
              </div>
            </Panel.Title>
            
          </Panel.Heading>
          <Panel.Body collapsible className='beneficio-contenido'>
            <h4>
              { this.props.item.CSImagenIconoText ? (
                <a href={this.props.item.CSImagenIconoText} className="beneficio-item-title-link" target="_blank">{this.props.item.CSTituloText}</a>
              ) : (
                this.props.item.CSTituloText
              ) }
            </h4>
            <div dangerouslySetInnerHTML={{__html: this.props.item.CSDescripcionRichTextNote}} />
          </Panel.Body>
      </Panel>
    );
  }
}

/******************** BUILD ********************/
const Panel = ReactBootstrap.Panel;
/******************** BUILD ********************/

